import { useFormik } from 'formik';
import React, { useState } from 'react';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import ImageGallery from './RenderImageGallery';
import { useInvoiceDetail } from './hooks';
import api from '../../../../../components/api';
import { ArrowLeft, MailIcon, Print } from '../../../../../components/atoms/icons';
import Modal from '../../../../../components/organisms/modals';
import Form from '../../../../../components/molecules/forms';

const modalStyles: Record<string, React.CSSProperties> = {
  sendMethodWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '1rem',
  },
  sendMethodLabel: {
    marginRight: '1rem',
    color: '#6b7280', // typical placeholder gray
    fontWeight: 500,
    fontSize: '14px',
  },
  sendMethodOptions: {
    display: 'flex',
    gap: '1rem',
  },
  radioOption: {
    marginRight: '1rem',
    display: 'flex',
    alignItems: 'center',
    gap: '0.3rem',
    fontSize: '14px',
  },
};

/* eslint-disable */
function ViewInvoice() {
    const ref = React.createRef();
    const navigation = useNavigate();
    const { invoiceData: data, isLoading } = useInvoiceDetail();
    const [result, setResult] = React.useState<any>(undefined);
    const [fileData, setFileData] = React.useState<any>(null)
    const [fileError, setFileError] = React.useState(false)
    const { mutate: sendInvoice, isLoading: sendInvoiceLoad } = useMutation(api.clients.sendCStoreInvoice, {
        onMutate: (variables) => console.log(variables),
        onSuccess: (data) => {
            console.log(data);
            setResult(data);
        },
        onError: (error) => {
            console.log(error);
            setResult(error);
        },
    });

    const dropDate = data?.invoice?.dropDate;
    const billDate = data?.invoice?.billDate;
    const clientName = data?.invoice?.clientName;
    // const contactPersonName = data?.invoice?.contactPerson?.firstname;
    const contactPerson = data?.invoice?.contactPerson;
    // const contactPerson: ContactPerson | undefined | null = data?.invoice?.contactPerson;
    const companyId = data?.invoice?.companyId;
    const orderId = data?.invoice?.orderId;
    const vmId = data?.invoice?.vmId;

    const yupSchema = yup.object().shape({
      name: yup.string().required("Name can't be empty"),
      sendMethod: yup.string().oneOf(['email', 'sms']),
      email: yup.string()
        .when('sendMethod', {
          is: (sendMethod : string) => sendMethod === 'email',
          then: yup.string()
            .required('Email is required!'),
        }),
      cellphone: yup.string()
        .when('sendMethod', {
          is: (sendMethod : string) => sendMethod === 'sms',
          then: yup.string()
            .required('Phone number is required!'),
        }),
    }, [['email', 'cellphone']]);

    const formik = useFormik({
        initialValues: {
            invoiceId: '',
            name: contactPerson?.['firstname'] ?? '',
            email: contactPerson?.['email'] ?? '',
            cellphone: contactPerson?.['phoneNumber'] ?? '',
            sendMethod: 'email',
        },
        validationSchema: yupSchema,
        onSubmit: (values) => {
            let formeData = new FormData();
            // formeData.append('file', fileData);
            formeData.append('invoiceId', values?.invoiceId);
            formeData.append('name', values?.name);
            formeData.append('email', values?.email);
            formeData.append('cellphone', values?.cellphone);
            formeData.append('sendMethod', values?.sendMethod);
            // if (!!fileData) {
            sendInvoice(formeData)
            // } else {
            //    setFileError(true)
            // }
        },
    });

    const getDateFormat = (date: Date) => `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;

    const renderModalBody = React.useMemo(() => {
        if (isLoading) return <div>Loading...</div>;
        return (
            <div>
                <Form.Default
                    id="name"
                    placeholder="Enter Name"
                    type="text"
                    value={formik.values.name}
                    onBlur={formik.handleBlur}
                    isInvalid={!!formik.errors.name && formik.touched.name}
                    errorMsg={formik.errors.name}
                    onChange={(e) => formik.setFieldValue('name', e.target.value)}
                />
                <div className='mt-4'>
                    <Form.Default
                        id="email"
                        placeholder="Enter Email"
                        type="text"
                        value={formik.values.email}
                        onBlur={formik.handleBlur}
                        isInvalid={!!formik.errors.email && formik.touched.email}
                        errorMsg={formik.errors.email}
                        onChange={(e) => formik.setFieldValue('email', e.target.value)}
                    />
                </div>
                <div className='mt-4'>
                    <Form.Default
                        id="cellphone"
                        placeholder="Enter Cellphone Number"
                        type="text"
                        value={formik.values.cellphone}
                        onBlur={formik.handleBlur}
                        isInvalid={!!formik.errors.cellphone && formik.touched.cellphone}
                        errorMsg={formik.errors.cellphone}
                        onChange={(e) => formik.setFieldValue('cellphone', e.target.value)}
                    />
                </div>
                <div style={modalStyles.sendMethodWrapper}>
                  <label style={modalStyles.sendMethodLabel}>Send Via</label>
                  <label style={modalStyles.radioOption}>
                    <input
                      type="radio"
                      name="sendMethod"
                      value="email"
                      checked={formik.values.sendMethod === 'email'}
                      onChange={(e) => formik.setFieldValue('sendMethod', e.target.value)}
                      className="mr-2"
                    />
                    Email
                  </label>
                  <label style={modalStyles.radioOption}>
                    <input
                      type="radio"
                      name="sendMethod"
                      value="sms"
                      checked={formik.values.sendMethod === 'sms'}
                      onChange={(e) => formik.setFieldValue('sendMethod', e.target.value)}
                      className="mr-2"
                    />
                    SMS
                  </label>
                </div>
            </div>
        );
    }, [formik, result]);

    const afterSendInvoice = () => {
        setResult(undefined);
        formik.setFieldValue('invoiceId', '')
        formik.setFieldValue('name', '')
        formik.setFieldValue('email', '')
        formik.setFieldValue('cellphone', '')
    };


    const generatePDF = async (id: any) => {
        const pdfData = await api.clients.getPDFByInvoiceId(id);
        const link = document.createElement('a');
        link.href = URL.createObjectURL(pdfData?.data);
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();

        // cleanup
        setTimeout(() => {
            link?.parentNode?.removeChild(link);
        }, 3000);
    };






    const S3HttpPath = `https://vending-webapp-resources.s3.amazonaws.com/images/order-pallet-images/${companyId}/`;

    const palletImages = data?.palletImages?.map(p =>
      `${S3HttpPath}${p.vmId}/${p.filename}`
    ) ?? [];

    return (
        <div className='invoice_container'>
            <div className="invoice_doc container ">
                <div className="invoice_top_bar">
                    <button
                        onClick={() => navigation(-1)}
                        type="button"
                        className="border-0 bg-transparent"
                        style={{ marginTop: '4px' }}
                    >
                        <ArrowLeft />
                    </button>
                    <span>Invoice</span>
                    <div className='d-flex'>
                        <div className="d-flex align-items-center justify-content-end" style={{ width: 120 }}>
                            <Modal.Default
                                cancelLabel="Cancel"
                                submitLabel="Send"
                                title="Send Invoice"
                                body={renderModalBody}
                                closeButton
                                isLoading={sendInvoiceLoad}
                                onAfterResult={afterSendInvoice}
                                result={result}
                                onInit={() => formik.setFieldValue('invoiceId', data?.invoice?.id)}
                                onSubmit={formik.handleSubmit}
                            >
                                <button
                                    type="button"
                                    className="border-0 pedding-btn bg-transparent"
                                    style={{ marginTop: '4px' }}
                                >
                                    <MailIcon />
                                </button>
                            </Modal.Default>
                        </div>
                        <button
                            onClick={() => generatePDF(data?.invoice?.id)}
                            type="button"
                            className="border-0 bg-transparent"
                            style={{ marginTop: '4px', paddingLeft: '10px' }}
                        >
                            <Print />
                        </button>
                    </div>
                </div>
                <div className="invoice_doc_second" style={{ borderBottom: '1px solid rgb(191, 191, 191)' }}>
                    <h3 className="invoice_heading">{`INVOICE#${data?.invoice?.id}`}</h3>
                    <div className="row invoice_doc_second_list">
                        <div className="col-sm-4">
                            <p>Bill To: </p>
                            <p>Ship To: </p>
                            <p>Bill Date: </p>
                        </div>
                        <div className="col-sm-6">
                            <p>{data?.invoice?.clientName}</p>
                            <p>{dropDate ? getDateFormat(new Date(dropDate)) : '-'}</p>
                            <p>{billDate ? getDateFormat(new Date(billDate)) : '-'}</p>
                        </div>
                    </div>
                </div>
                <div className="invoice_doc_second">
                    <div className="row invoice_doc_second_list">
                        <div className="col-sm-4">
                            <p>Ship Date: </p>
                            <p>Bill Date: </p>
                        </div>
                        <div className="col-sm-6">
                            <p>{dropDate ? getDateFormat(new Date(dropDate)) : '-'}</p>
                            <p>{billDate ? getDateFormat(new Date(billDate)) : '-'}</p>
                        </div>
                    </div>
                </div>

                <div className="row table_part">
                    <div className="col-sm-12">
                        <table className="table bordered">
                            <thead className="">
                                <tr>
                                    <th scope="col">S.No</th>
                                    <th scope="col">Description</th>
                                    <th scope="col">Qty</th>
                                    <th scope="col">Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data?.orders && data?.orders?.length > 0 ?
                                    data?.orders?.map((item: any, i: number) => {
                                        return (
                                            <tr>
                                                <th scope="row">{i + 2}</th>
                                                <td>{item.productName}</td>
                                                <td>{item.quantity}</td>
                                                <td>${item.salesPrice}</td>
                                            </tr>
                                        );
                                    })
                                    : null}
                            </tbody>
                            <tfoot className="table_footer_data">
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td>Total:</td>
                                    <td>${data?.invoice?.billAmount}</td>
                                </tr>
                            </tfoot>
                        </table>

                    </div>
                </div>
                {palletImages.length > 0 && (
                  <div className="mt-4">
                    <h5>Pallet Images</h5>
                    <ImageGallery images={palletImages} />
                  </div>
                )}
            </div>
        </div>
    )
}

export default ViewInvoice;